import { MIMETYPE_JSON } from 'cadenza/model/media-type';
import { ajax } from 'cadenza/api-client/api';
import { logger } from 'cadenza/utils/logging';

export function setPerformanceMetadata (metadata: Record<string, string>) {
  return ajax<undefined>('/session/performanceMetadata', {
    type: 'PUT',
    data: JSON.stringify(metadata),
    contentType: MIMETYPE_JSON
  })
    .catch(e => {
      if (e.status === 404) {
        logger.error('Performance Logging Metadata Feature is not enabled.');
      }
    });
}

export function clearPerformanceMetadata () {
  return ajax('/session/performanceMetadata', {
    type: 'DELETE'
  })
    .catch(e => {
      if (e.status === 404) {
        logger.error('Performance Logging Metadata Feature is not enabled.');
      }
    });
}
